console.log('Website design and developed by Pretty Pragmatic.');

/**
 * ------------------------
 *  CONTENTS
 * ------------------------
 * 1. Mobile Navigation
 * 2. Contact Form Textarea Count
 * 3. Contact Form Tooltip
 * 4. Cookies Banner
 * 5. Footer Accordian
 * 6. Footer - Date
 * 7. PDF Block Show More
 * 8. Banner carousel
 */

// 1. Mobile Nav Button
//--------------------------

if (document.querySelector('.lvp-hamburger')) {
	// If hamburger menu icon exists on page.
	// button element
	const ham = document.querySelector('.lvp-hamburger');
	const navBar = document.querySelector('#primary-navigation');

	ham.addEventListener("click", function () {

		// Toggle class on and off to trigger CSS SVG animation.
		ham.classList.toggle('is-active');

		// Set aria aria-pressed = true
		ham.setAttribute("aria-pressed", ham.classList.contains('opened'));

		// Toggle active class to show/hide nav links.
		navBar.classList.toggle('active');

		document.querySelector('html').classList.toggle('noscroll-mobile');
	})


	//ch-nav-dropdown
	//are there any child links?
	if (document.querySelector('.ch-nav-dropdown')) {
		const haveDropdowns = document.querySelectorAll('.ch-nav-dropdown');
		haveDropdowns.forEach(dd => {

			const ddToggle = dd.querySelector('.js-toggleDropdown');
			const ddLink = dd.querySelector('a');
			const dropdown = dd.querySelector('.ch-nav-dropdown-ul');

			ddToggle.addEventListener("click", function (e) {
				ddToggle.classList.toggle('active');
				e.preventDefault();
			});
		});
	}
}

// 2. Contact Form - Textarea Count
// --------------------------------------

if (document.getElementById('Message')) {
	const txtArea = document.getElementById('Message'); // teaxtarea

	const txtCounter = document.getElementById('counter'); //counter output <p>

	txtArea.addEventListener('input', function (e) {
		const target = e.target;

		// Get the `maxlength` attribute
		const maxLength = target.getAttribute('maxlength');

		// Count the current number of characters
		const currentLength = target.value.length;

		if (currentLength < 1) {
			// If nothing is typed.
			txtCounter.innerHTML = '';

			// Set aria-hidden.
			txtCounter.setAttribute('aria-hidden', 'true');
		} else {
			// Output values if charecters typed.
			txtCounter.innerHTML = `${currentLength}/${maxLength}`;

			// Set aria-hidden.
			txtCounter.setAttribute('aria-hidden', 'false');
		}
	});
}

// 3. Form ToolTip
// ---------------------------

// If the tooltip exists and if the screen size is tablet or less
// we make the tooltip clickable as ;hover will not be available.

if (document.querySelector("[role=tooltip]") &&
	document.querySelector(".ch-required-asterisk") &&
	document.querySelector(".ch-required-tooltip") &&
	window.outerWidth < 1144) {

	// Astyrisk element array.
	const tooltip = document.querySelectorAll(".ch-required-asterisk");

	tooltip.forEach(tip => {

		// The tooltip content.

		const parent = tip.parentElement;
		const child = parent.firstElementChild;
		const toolTipText = child.firstElementChild;

		// Add event listner to each asterisk.

		// When clicked show/hide the tooltip.

		// This is for mobile devices as hover doesn't work there.

		tip.addEventListener("click", function () {
			// toolTipText.classList.toggle(".ch-js-tooltip");
			toolTipText.style.visibility = toolTipText.style.visibility === 'hidden' ? 'visible' : 'hidden';

			///TO DO: Aria-Hidden.
		});
	});
}



// 3b. Form OtherField
// ---------------------------
if (document.querySelector(".js-gatedHasOtherField")) {
	var allOtherFields = document.querySelectorAll(".js-gatedHasOtherField").forEach(hasOtherFields => {
		var specifyOtherField = hasOtherFields.nextElementSibling;
		var theSelect = hasOtherFields.querySelector('select');
		checkOtherInput(theSelect, specifyOtherField);

		theSelect.addEventListener('change', () => {

			checkOtherInput(theSelect, specifyOtherField);
		});
	});

	function checkOtherInput(theSelect, specifyOtherField) {
		if (theSelect.value.toLowerCase().indexOf("other") > -1) {
			specifyOtherField.classList.remove('ch-visually-hidden');
		} else {
			specifyOtherField.classList.add('ch-visually-hidden');
		}
	}
}

// 4. Cookies Popup - REMOVED (now using OneTrust)
//--------------------------------------------

// 5. Footer Accordian on Mobile
//--------------------------------------------

if (document.querySelector('#footer-navigation')) {
	// If Footer menu is on the page.

	// button element
	const h = document.querySelectorAll('.ch-footer-title');

	h.forEach(el => {

		el.addEventListener("click", function () {

			// UL list of links.
			const links = el.nextElementSibling;

			// Toggle class on and off to trigger SVG rotate.
			el.classList.toggle('active');

			// Toggle active class to show/hide nav links.
			links.classList.toggle('active');
		})
	});
}

// 6. Footer - Date
//--------------------------------------------

if (document.querySelector('#footer')) {

	// Lower Footer
	const footer = document.querySelector('.footer__lower');

	// Date
	const date = new Date().getUTCFullYear();

	footer.firstElementChild.innerHTML = "&copy; Chartwells " + date;
}

// 7. PDF Block Show More
//--------------------------------------------

if (document.querySelector('.ch-pdf-cards') && document.querySelector('.ch-pdf-hidden')) {
	const MAX_PDFS = 3;
	const showMoreBtns = document.querySelectorAll('.ch-pdf-showmore');
	showMoreBtns.forEach(showMoreBtn => {
		showMoreBtn.addEventListener('click', function (ev) {
			ev.preventDefault();

			// select parent container and all child elements with hidden class
			const parent = showMoreBtn.closest('.ch-callout-cardslist');
			const hiddenPDFs = parent.querySelectorAll('.ch-pdf-hidden');

			// show the first 3 hidden PDFs
			let counter = 1;
			hiddenPDFs.forEach(pdf => {
				if (counter > MAX_PDFS) {
					return;
				}
				pdf.classList.remove('ch-pdf-hidden');
				counter++;
			});

			// if all PDFs are shown, hide the show more button
			if (hiddenPDFs.length <= MAX_PDFS) {
				showMoreBtn.style.display = 'none';
			}
		});
	});
}

// 8. Banner carousel
//--------------------------------------------

const glideImageCarousel = ".glide";

// default carousel settings
const defaultCarouselConfig = {
	type: "slider",
	startAt: 0,
	perView: 1,
	gap: 0,
	autoplay: 6000,
	animationDuration: 600,
	dragThreshold: 50,
	swipeThreshold: 20,
	hoverpause: false,
	focusAt: "center",
};

if (document.getElementsByClassName("glide").length > 0) {
	createCarousel();
}

function createCarousel() {
	document.querySelectorAll(glideImageCarousel).forEach((el) => {
		const glide = new Glide(el, defaultCarouselConfig).mount();

		// set up progress indicator
		el.querySelectorAll('.glide__bullet').forEach((bullet) => {
			const circle = bullet.querySelector('.ch-progress-indicator');
			const totalLength = circle.getTotalLength();
			circle.setAttribute("stroke-dasharray", "0, " + totalLength);
		});

		glide.on('move.after', function () {
			const index = glide.index;
			const slide = el.querySelectorAll(".glide__slide")[index];
			const activeBullet = el.querySelector('.glide__bullet--active');

			if (slide.querySelector('.ch-banner-carousel__slide-content').getAttribute('data-colour-class')) {
				const colourClass = slide.querySelector('.ch-banner-carousel__slide-content').getAttribute('data-colour-class');
				el.parentElement.classList.remove('ch-bg-yellow', 'ch-bg-teal', 'ch-bg-green', 'ch-bg-brown');
				el.parentElement.classList.add(colourClass);
			}

			// reset all progress bullets
			el.querySelectorAll('.glide__bullet').forEach((bullet) => {
				const circle = bullet.querySelector('.ch-progress-indicator');
				const totalLength = circle.getTotalLength();
				window.clearInterval(window.timer);
				circle.setAttribute("stroke-dasharray", "0, " + totalLength);
			});

			if (activeBullet) {
				// initialise active progress bullet
				let angle = 0;
				const circle = activeBullet.querySelector('.ch-progress-indicator');
				const totalLength = circle.getTotalLength();
				const duration = defaultCarouselConfig.autoplay;
				const increment = totalLength / 360;
				circle.setAttribute("stroke-dasharray", "0, " + totalLength);

				window.timer = window.setInterval(function () {
					circle.setAttribute("stroke-dasharray", angle + ", " + totalLength);
					if (angle >= totalLength) {
						window.clearInterval(window.timer);
						circle.setAttribute("stroke-dasharray", "0, " + totalLength);
					}
					angle += increment;
				}.bind(this), duration / 360);
			}
		});
	});
}